import React, { FunctionComponent } from 'react'
import DOMPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'
import { useTranslation } from 'react-i18next'

export interface PublicationAreaProps {
  heading: string | null
  HTMLNumbers: boolean | false
  replaceLogoEpub: string | null
  hideDefaultLogo: boolean | false
  publicationNumber: string | null
  publicationDate: string | null
  author: string | null
  coverPagePrintImage: string | null
  publicationHtml: string | TrustedHTML
  publicationAreaRef: React.RefObject<HTMLDivElement | null>
  htmlDocRef: React.RefObject<HTMLDivElement | null>
  printMenuRef: React.RefObject<HTMLDivElement | null>
}
const PublicationArea: FunctionComponent<PublicationAreaProps> = (props) => {
  const { t } = useTranslation()
  const {
    publicationAreaRef,
    htmlDocRef,
    HTMLNumbers,
    replaceLogoEpub,
    hideDefaultLogo,
    publicationNumber,
    heading,
    author,
    coverPagePrintImage,
    publicationHtml,
    publicationDate,
    printMenuRef,
  } = props

  const sanitizedData = DOMPurify.sanitize(publicationHtml as string)

  return (
    <>
      <div className={`publicationarea ${HTMLNumbers ? 'shownumbers' : ''}`} ref={publicationAreaRef}>
        {replaceLogoEpub && <img className={hideDefaultLogo ? '' : 'twoimages'} src={replaceLogoEpub} alt="" />}
        {!hideDefaultLogo && <img className="livslogo" src="/images/logo.png" alt="Livsmedelsverket logo" />}
        {publicationNumber && <div className="pubnumber">{publicationNumber}</div>}
        <h1>{heading}</h1>
        <div className="infocontainer">
          {publicationDate && (
            <div className="info">
              <div>{t('published')}</div>
              <div>{publicationDate}</div>
            </div>
          )}
          {author && (
            <div className="info">
              <div>{t('author')}</div>
              <div>{author}</div>
            </div>
          )}
          {coverPagePrintImage && <img className="coverPrintImage" src={coverPagePrintImage} alt="" />}
        </div>
        <div className="pagebreak"></div>
        <span ref={printMenuRef} id="print-menu" className="toc-menu"></span>
        <div className="pagebreak"></div>
        <div ref={htmlDocRef}>{ReactHtmlParser(sanitizedData)}</div>
      </div>
    </>
  )
}

export default PublicationArea
